/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import {
  call,
  put,
  takeLatest,
  all,
  takeEvery,
  select,
  takeLeading,
} from "redux-saga/effects";
import * as playerActions from "./actions";
import * as datapipeActions from "../datapipe/actions";
import {
  collectorDataPipeBO,
  updateSelecteionOnCollectorAddInAllSections,
} from "../datapipe/helper";
import {
  FetchPlayers,
  FetchAPlayer,
  FetchPlayerList,
  FetchAPlayerV3,
  FetchAPlayerForAddDatapipe,
  FetchPlayerRestrictionList,
  CreatePlayerRestriction,
  DeletePlayerRestriction,
} from "./services";
import { getPlayerCompany, getPlayerEntities } from "./selector";
import { getCurrentDatapipe } from "../datapipe/selector";
import { ADMIN_ROLE, USER_ROLE } from "../../app/Constants/Constants";
import { getV3PlayerBO, getV3PlayerBO_v2 } from "./helper";
import { addCustomEvent, getPipeNewUI } from "../../app/Utilities/utils";
import { getauth } from "../auth/selectors";

// worker saga: makes the api call when watcher saga sees the action
export function* fetchPlayerSaga(action) {
  try {
    const response = yield call(FetchPlayers, action.payload);

    const players =
      response.data && response.data.data ? response.data.data : [];
    players.list = players;
    yield put(playerActions.FetchPlayersSuccess(players));
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(playerActions.FetchPlayersFailed(error));
  }
}

export function* fetchAPlayerSaga(action) {
  const currentDatapipe = yield select(getCurrentDatapipe);
  let company = null;
  if (currentDatapipe && currentDatapipe.companyId) {
    company = currentDatapipe.companyId;
  } else {
    company = yield select(getPlayerCompany);
  }
  try {
    const response = yield call(FetchAPlayer, action?.payload);
    const player =
      response.data && response.data.data ? response.data.data[0] : {};
    yield put(playerActions.FetchAPlayerSuccess(player));
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(playerActions.FetchAPlayerFailed(error));
  }
}

export function* fetchAPlayerV3Saga(action) {
  const currentDatapipe = yield select(getCurrentDatapipe);
  let company = null;
  if (currentDatapipe && currentDatapipe.companyId) {
    company = currentDatapipe.companyId;
  } else {
    company = yield select(getPlayerCompany);
  }
  company =
    action.payload?.roleName === ADMIN_ROLE ||
    action.payload?.roleName === USER_ROLE
      ? ""
      : company;
  try {
    const response = yield call(FetchAPlayerV3, action.payload?.id, company);
    const player = response?.data?.data ? response?.data?.data : {};
    yield put(playerActions.FetchAPlayerV3Success(player));
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(playerActions.FetchAPlayerV3Failed(error));
  }
}

export function* fetchAPlayerPutToDatapipe(action) {
  try {
    const currentDatapipe = yield select(getCurrentDatapipe);
    let company = null;
    if (currentDatapipe && currentDatapipe.companyId) {
      company = currentDatapipe.companyId;
    } else {
      company = yield select(getPlayerCompany);
    }
    const playerEntities = yield select(getPlayerEntities);
    let player = playerEntities?.[action?.payload?.data?.playerId];
    company =
      action.payload.roleName === ADMIN_ROLE ||
      action.payload.roleName === USER_ROLE
        ? ""
        : company;
    if (player === undefined) {
      const response = yield call(
        FetchAPlayerV3,
        action?.payload?.data?.playerId,
        company,
      );
      player = response?.data?.data ? getV3PlayerBO(response?.data?.data) : {};
      yield put(playerActions.FetchAPlayerSuccess(addCustomEvent(player)));
    }
    yield put(
      datapipeActions.AddCollectorTODatapipe(
        collectorDataPipeBO(action.payload.data, addCustomEvent(player)),
      ),
    );
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(playerActions.FetchAPlayerFailed(error));
  }
}
export function* FetchAPlayerPutToDatapipeV3_1(action) {
  try {
    const currentDatapipe = yield select(getCurrentDatapipe);
    let company = null;
    if (currentDatapipe && currentDatapipe.companyId) {
      company = currentDatapipe.companyId;
    } else {
      company = yield select(getPlayerCompany);
    }
    // const playerEntities = yield select(getPlayerEntities);
    // console.log("playerEntities-141", playerEntities);
    // let player = playerEntities?.[action?.payload?.data?.playerId];
    company =
      action.payload.roleName === ADMIN_ROLE ||
      action.payload.roleName === USER_ROLE
        ? ""
        : company;
    // if (player === undefined) {
    const response = yield call(
      FetchAPlayerForAddDatapipe,
      action?.payload?.data?.id,
    );
    const player = response?.data?.data
      ? getV3PlayerBO_v2(response?.data?.data, action?.payload?.data?.id)
      : {};

    const isNewDatapipeUI = getPipeNewUI();
    if (isNewDatapipeUI) {
      const cdnCollectors = [
        "Fastly CDN",
        "Lumen",
        "Amazon CloudFront",
        "Akamai CDN",
      ];
      if (cdnCollectors.some((name) => player?.collectorName?.includes(name))) {
        player.collectorType = "CDN";
      } else {
        player.collectorType = "APP_COLLECTOR";
      }
      if (currentDatapipe?.collectorConfigs?.length > 0) {
        const auth = yield select(getauth);
        updateSelecteionOnCollectorAddInAllSections(
          currentDatapipe,
          player,
          auth,
        );
      }
    }
    yield put(playerActions.FetchAPlayerSuccess(player));
    // }
    yield put(datapipeActions.AddCollectorTODatapipe(player));
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(playerActions.FetchAPlayerFailed(error));
  }
}
export function* fetchPlayerListSaga(action) {
  try {
    const response = yield call(FetchPlayerList, action.payload);
    const players =
      response.data && response.data.data ? response.data.data : [];
    // players.list = players;
    yield put(playerActions.FetchPlayerLIstSuccess(players));
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(playerActions.FetchPlayerListFailed(error));
  }
}

export function* fetchPlayerRestrictionListSaga(action) {
  try {
    const response = yield call(FetchPlayerRestrictionList, action?.payload);
    yield put(
      playerActions.FetchPlayerRestrictionListSuccess(response?.data?.data),
    );
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(playerActions.FetchPlayerRestrictionListFailed(error));
  }
}
export function* createPlayerRestrictionSaga(action) {
  try {
    const response = yield call(CreatePlayerRestriction, action?.payload);
    yield put(playerActions.CreatePlayerRestrictionSuccess(response.data));
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(playerActions.CreatePlayerRestrictionFailed(error));
  }
}
export function* deletePlayerRestrictionSaga(action) {
  try {
    const response = yield call(DeletePlayerRestriction, action?.payload);
    yield put(playerActions.DeletePlayerRestrictionSuccess(response?.data));
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(playerActions.DeletePlayerRestrictionFailed(error));
  }
}
// watcher saga: watches for actions dispatched to the store, starts worker saga
export function* playerWatcher() {
  yield all([
    takeLatest(playerActions.types.FETCH_PLAYERS, fetchPlayerSaga),
    takeEvery(
      playerActions.types.FETCH_A_PLAYER_PUT_DATAPIPE,
      fetchAPlayerPutToDatapipe,
    ),
    takeEvery(
      playerActions.types.FETCH_A_PLAYER_PUT_DATAPIPE_V3_1,
      FetchAPlayerPutToDatapipeV3_1,
    ),
    takeEvery(playerActions.types.FETCH_A_PLAYER, fetchAPlayerSaga),
    takeLatest(playerActions.types.FETCH_PLAYER_LIST, fetchPlayerListSaga),
    takeLatest(playerActions.types.FETCH_A_PLAYER_V3, fetchAPlayerV3Saga),
    takeLatest(
      playerActions.types.FETCH_PLAYER_RESTRICTION_LIST,
      fetchPlayerRestrictionListSaga,
    ),
    takeLeading(
      playerActions.types.CREATE_PLAYER_RESTRICTION,
      createPlayerRestrictionSaga,
    ),
    takeLeading(
      playerActions.types.DELETE_PLAYER_RESTRICTION,
      deletePlayerRestrictionSaga,
    ),
  ]);
}
